import React from "react";
import { Container } from "react-bootstrap";
import * as s from "./index.module.scss";
import SimilarBlogs from "../SimilarBlogs";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";
import Link from "next/link";

const BlogContent = ({ data, prevUid, nextUid, parentPage = "" }) => {
  return (
    <section className={`section-center ${s.blog_content}`}>
      <Container>
        <div className={s.header}>
          <h5 className="fw-normal">
            Published {data?.dateM + " " + data?.dateD + ", " + data?.dateY}
          </h5>
          <h1 className="heading">{data?.passPage?.title}</h1>
        </div>
        <div className={s.img_container}>
          <img
            loading="lazy"
            src={data?.passPage?.image.url}
            alt={data?.passPage?.image.alt || "image"}
          />
        </div>
        <div className="d-md-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center mb-3 mb-md-0">
            {data?.passPage?.category && (
              <div className={s.category}>
                <p className={`${secondaryFont}`}>{data?.passPage?.category}</p>
              </div>
            )}
            <div>
              <p className={`${secondaryFont}`}>
                {data?.dateD + " " + data?.dateM + " " + data?.dateY}
              </p>
            </div>
          </div>
        </div>
        <div className={`blog_body_inv ${s.blog_body}`}>
          <div>
            <PrismicRichText field={data?.passPage?.description || []} />
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            {prevUid && (
              <Link
                href={`/${parentPage}/${prevUid}`}
                className={`btn btn-link p-0 ${s.pre_link}`}
                style={{}}
              >
                Previous
              </Link>
            )}
          </div>
          <div>
            {nextUid && (
              <Link
                href={`/${parentPage}/${nextUid}`}
                className={`btn btn-link p-0 ${s.next_link}`}
              >
                Next
              </Link>
            )}
          </div>
        </div>
        <div className={s.similar_blogs}>
          <SimilarBlogs data={data?.recentBlog} />
        </div>
      </Container>
    </section>
  );
};

export default BlogContent;
